<div class="w-full bg-white flex flex-col pl-5 pr-5 2xs:pl-10 2xs:pr-10 md:pr-2 lg:pr-0 lg:pl-0 pt-2">
  <div class="w-full lg:ml-auto lg:mr-auto lg:w-[1024px] 2xl:w-[90rem] z-9994 mt-10 flex flex-col
        lg:bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/red-man.svg)] bg-no-repeat bg-red-man-position">

    <h2 class="w-full font-theme-source text-2xl sm:text-3xl leading-[1.4] lg:leading-[1.3] lg:text-5xl text-theme-black font-theme-source font-bold text-left">
      Encore des questions ?<br />
      On y répond ici !
    </h2>
    <p class="font-theme-source text-base sm:text-base lg:text-base text-theme-black font-theme-source mt-3 lg:pr-100">
      Une partie des réponses à tes interrogations sont dans la FAQ et si rien n’y répond, contacte Sébastien via <a class="font-bold text-theme-red-110" href="mailto:sebastien@7minutespourtoi.fr" aria-label="Envoyer Email">
      sebastien&#64;7minutespourtoi.fr</a> ou en cliquant sur le bouton ci dessous, il te répondra sous 48h.
    </p>
    <p class="text-left w-[200px] mt-5">
      <app-lp-cta text="Envoyer un message" [myRouterLink]="'/contact'"></app-lp-cta>
    </p>

    <div class="w-full">
      <!-- Question 1 -->
      <hr class="w-full lg:mt-10 md:mt-12 md:mb-8 my-8" />

      <div class="w-full md:px-6">
        <div class="mainHeading flex justify-between items-center w-full">
          <div class="">
            <h3 class="flex justify-center items-center  leading-6 md:leading-4 text-theme-black font-theme-source ">
              <span class="lg:mr-6 mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">Le speed dating, c'est quoi ?</span></h3>
          </div>
          <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
            <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
          </button>
        </div>
        <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
          <p class="pb-2">Les speed datings pour célibataires sont des événements dans lesquels des personnes recherchant une relation sentimentale se retrouvent pour des rencontres en tête à tête s'effectuant sur une durée limitée.</p>
          <p class="pb-2">Le principe : Certain(e)s sont assis(e)s à une table fixe et leurs prétendant(e)s  changent de table toutes les 7 minutes pour un rendez-vous avec une nouvelle personne.</p>
          <p class="pb-2">Chaque changement de tour de 7 minutes fait l'objet d'une musique marquant la fin du tour en cours et le début du tour suivant, en invitant les Messieurs à rencontrer leur prochaine partenaire.</p>
          <p class="pb-2">Chaque participant possède une fiche avec la liste des personnes rencontrées, et a la possibilité d'indiquer sur celle-ci une ou plusieurs prétendant(e)s pour lesquels il souhaite son numéro de télephone,
            on appelle  cela des « Coups de coeur ».</p>
          <p class="pb-2">C'est après le dépouillement des fiches de tous les participants par les organisateurs qu'il y a detection des souhaits de coordonnées réciproques (souvent apellé « Match »), provoquant l'obtention par les
            prétendants concernés des numéros de télephone des personnes avec lesquelles un Match a eu lieu.</p>
          <p class="pb-2">A noter qu'avec <i>7 minutes pour toi</i>, une animation soignée et de nombreuses options permettent d'agrémenter ce fonctionnement traditionnel
            : changement des coups de coeur après la soirée, visualisation des prétendants qui t'ont adressé un coup de coeur, envoi des coups de coeur à ses prétendant(e)s etc.</p>

        </div>
      </div>


      <hr class="w-full lg:mt-10 my-8" />

      <div class="w-full md:px-6">
        <div class="mainHeading flex justify-between items-center w-full">
          <div class="">
            <h3 class="flex justify-center items-center  leading-6 lg:leading-4 text-theme-black font-theme-source ">
              <span class="lg:mr-6  mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">
                Où sont réalisés les speed dating à Nantes ?
              </span>
            </h3>
          </div>
          <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
            <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
          </button>
        </div>
        <div  class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source  font-normal">
          <p class="pb-2">Les soirées ont lieu dans des établissements nantais sélectionnés pour leur atmosphère, leur confort et leur accessibilité. L'adresse exacte, la date,
            les horaires et la tranche d'âge concernée sont indiqués sur la page de chaque événement avant ton inscription.</p>

        </div>
      </div>

      <hr class="w-full lg:mt-10 my-8" />

      <div class="w-full md:px-6">
        <div class="mainHeading flex justify-between items-center w-full">
          <div class="">
            <h3 class="flex justify-center items-center  leading-6 lg:leading-4 text-theme-black font-theme-source ">
              <span class="lg:mr-6  mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">
                À qui s'adressent les soirées pour célibataires à Nantes ?
              </span>
            </h3>
          </div>
          <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
            <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
          </button>
        </div>
        <div  class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source  font-normal">
          <p class="pb-2">Elles s'adressent aux adultes célibataires qui souhaitent faire des rencontres réelles à Nantes, qu'ils recherchent une belle conversation, un nouveau feeling ou une relation sérieuse.
            Chaque événement précise les tranches d'âge et les profils concernés afin que tu puisses choisir la soirée la plus adaptée.</p>

        </div>
      </div>



      <!-- Question 2 -->

      <hr class="w-full lg:mt-10 my-8" />

      <div class="w-full md:px-6">
        <div class="mainHeading flex justify-between items-center w-full">
          <div class="">
            <h3 class="flex justify-center items-center  leading-6 lg:leading-4 text-theme-black font-theme-source ">
              <span class="lg:mr-6  mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">
                Je suis timide ou reservé(e), est-ce que les speed dating sont faits pour moi ?
              </span>
            </h3>
          </div>
          <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
            <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
          </button>
        </div>
        <div  class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source  font-normal">
          <p class="pb-2">Rassure-toi, il est tout à fait naturel de ressentir de l'appréhension à l'idée de rencontrer des inconnu.e.s : Peur de ne pas savoir quoi dire, du jugement sur l'apparence etc. Ce sentiment qui nous est tous familier
            peut provoquer un blocage nous empechant de franchir le pas, et nous le comprenons.</p>
          <p class="pb-2">C'est pourquoi nous attachons une importance primordiale à l'accueil individuel de tous nos participants à nos évenements. Nous t'expliquons le fonctionnement, et te rassurons en mettant tout en oeuvre
            pour créer une atmosphère détendue, sécurisante et joviale.</p>
          <p class="pb-2">Nous tenons par ailleurs à te rassurer : ton stress disparaitra dès les premières secondes du premier rendez-vous, car tous nos participants font preuve d'une bienveillance absolue.</p>
          <p class="pb-2">Il est également fort à parier que tu n'auras pas de blanc dans tes conversations dans les rendez-vous en tête à tête, car les discussions se font toujours de manière très naturelle sans que l'on s'en rende compte : Tu feras
            part de tes sensations du moment qui seront partagées par tes prétendant.e.s, ce qui déclenchera sourires, rires et un début de complicité. Et oui, n'oublie pas que les personnes que tu rencontreras ressentent
            le plus souvent les mêmes choses que toi, il viennent en général à ce type de soirée pour la première fois !</p>
          <p class="pb-2">Enfin, nous venons d'ajouter la possibilité d'indiquer tes hobbies lors de l'inscription, qui seront partagés à tes prétendant.e.s., ce qui permettra à coup sûr de briser la glace !</p>
        </div>
      </div>

      <!-- Question 3 -->

      <hr class="w-full lg:mt-10 my-8" />

      <div class="w-full md:px-6">
        <div class="mainHeading flex justify-between items-center w-full">
          <div class="">
            <h3 class="flex justify-center items-center   leading-6 lg:leading-4 text-theme-black font-theme-source ">
              <span class="lg:mr-6  mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">
                Comment sélectionnez-vous les personnes que je vais rencontrer ?
              </span>
            </h3>
          </div>
          <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
            <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
          </button>
        </div>
        <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
          <p class="pb-2">Nous créons un planning de rencontre personnalisé pour chaque célibataire de la soirée, contenant jusqu'à 10 rencontres avec des prétendant.e.s pour lesquels
            les souhaits de tranche d'âge sont sensiblement et réciproquement compatibles.
          </p>
        </div>
      </div>

      <!-- Question 4 -->

      <hr class="w-full lg:mt-10 my-8" />

      <div class="w-full md:px-6">
        <div class="mainHeading flex justify-between items-center w-full">
          <div class="">
            <h3 class="flex justify-center items-center   leading-6 lg:leading-4 text-theme-black font-theme-source ">
              <span class="lg:mr-6  mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">
                En quoi vos speed dating sont différents des autres ?
              </span>
            </h3>
          </div>
          <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
            <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
          </button>
        </div>
        <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
          <p class="pb-2">Nos speed dating se distinguent par bien des aspects, notamment :</p>
          <ul class="list-disc pl-5 mb-5">
            <li>La parité Hommes/Femmes ou des profils compatibles</li>
            <li>Les plannings personnalisés (tu choisis ton propre tranche d'âge souhaitée à l'inscription)</li>
            <li>Le nombre de rencontres par participants : celui-ci est presque à chaque fois entre 7 et 10 (Tout dépend de tes critères de recherche).</li>
            <li>Le nombre de participants, celui-ci varie entre 40 et 65 personnes.</li>
            <li>Plusieurs choix de coups de coeur maximum possibles et options inédites : modification des coups de coeurs à posteriori par exemple.</li>
          </ul>
          <p class="pb-2">Tu l'as compris, nous mettons tout en oeuvre pour que tu fasses un maximum de rencontres et augmenter tes chances de trouver l'amour !</p>
        </div>
      </div>

      <!-- Question 5 -->

      <hr class="w-full lg:mt-10 my-8" />

      <div class="w-full md:px-6">
        <div  class="mainHeading flex justify-between items-center w-full">
          <div class="">
            <h3 class="flex justify-center items-center  leading-6 lg:leading-4 text-theme-black font-theme-source ">
              <span class="lg:mr-6  mr-4 lg:text-2xl md:text-xl text-lg leading-6 md:leading-5 lg:leading-4 font-bold text-theme-black font-theme-source ">
                7 minutes me paraît très court pour un rendez-vous, pourquoi est-ce ainsi ?
              </span>
            </h3>
          </div>
          <button aria-label="toggler" class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" data-menu>
            <img loading="lazy" decoding="async" class="transform " src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/faq/arrow-down.svg" alt="toggler">
          </button>
        </div>
        <div class="menu hidden mt-6 w-full text-base sm:text-base lg:text-base leading-[1.8] text-theme-black font-theme-source font-normal">
          <p class="pb-2">Notre expérience a montré que les impressions les plus marquantes se font dans les toutes premières minutes. Pour les femmes, hommes ou personnes non-binaires, les coups de coeurs se révèlent non pas
            grâce une discussion sur un sujet de tous les jours, mais le plus souvent sur une sensation, une vibration émotionnelle, une attitude, bref quelque chose d'inattendu et de très naturel révélant la personnalité
            du/de la prétendant.e en face.</p>
          <p class="pb-2">En provoquant des moments spontanés et fragiles, on encourage à réveiller un maximum d'émotion  et de vérité dans l'expression de nous même, quelque chose dont on se souvient à coup sûr, et qui étant par nature
            souvent trop court, invite à souhaiter un échange des numéros de télephone.</p>
          <p class="pb-2">Les rendez-vous de 7 minutes permettent également de pouvoir rencontrer un maximum de célibataires en un minimum de temps en une seule soirée, ce qui augmente considérablement les opportunités de coup de coeur.</p>
          <p class="pb-2">Si la durée de 7 minutes est souvent frustrante car perçue comme trop courte, elle rappelle l'objectif premier du speed dating qui est de provoquer
            l'envie d'un deuxième rendez-vous, et non la nécessité de tout raconter sur soi.</p>
        </div>
      </div>

      <hr class="w-full lg:mt-10 my-8" />
    </div>

  </div>
</div>
